import "./style.scss";

import Button from '../common/button';
import LinkButton from "../common/linkButton";

const DistrictForm = (props) => {
  const {
    submitLabel,
    submitAction,
    children,
    disabled,
    cancelAction
  } = props;

  return (
    <form className='save-district-form'>
      <div className='form-items'>
        { children }
        <div className='form-button'>
          {cancelAction && <LinkButton label='Cancel' clickAction={cancelAction}/>}
          <Button label={submitLabel} action={submitAction} disabled={disabled}/>
        </div>
      </div>
    </form>
  );
};

export default DistrictForm;
